import React from 'react'
import DeleteIcon from './Icons/DeleteIcon'

const DeleteButton = ({ onClick }) => {
  return (
    <button
      className="btn btn-circle btn-ghost btn-sm"
      onClick={(e) => {
        e.stopPropagation()
        onClick()
      }}
    >
      <DeleteIcon />
    </button>
  )
}

export default DeleteButton
